// extracted by mini-css-extract-plugin
module.exports = {"fieldGroup":"styles_fieldGroup__3Pqhl","light":"styles_light__2-sL5"};